import { createBaseCRUDApi } from '@/api/base'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'

export const PARTNER_URL = 'partner'
const errors = createBaseResponseErrors('контрагента', 'контрагентов')

export const PartnerApi = {
  ...createBaseCRUDApi(PARTNER_URL, errors)
}
